import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { SpinnerComponent } from './spinner.component';

/** Standalone-ish home for app-spinner so it can be reused at the app root
 *  (global overlay) without importing the whole shared module. */
@NgModule({
  declarations: [SpinnerComponent],
  imports: [CommonModule, ProgressSpinnerModule],
  exports: [SpinnerComponent]
})
export class SpinnerModule {}
